/* 4kaad ES — Mejora progresiva del mega-menu de la nav fallback (escritorio).
   Base accesible sin JS: cada categoria es <details>/<summary> (abre con teclado).
   Con JS anadimos: apertura por hover, cierre con Esc, cierre al hacer clic fuera,
   y solo un panel abierto a la vez. aria-expanded se sincroniza con el estado.        */
(function () {
  'use strict';

  var nav = document.querySelector('.nav4k');
  if (!nav) return;

  var items = Array.prototype.slice.call(nav.querySelectorAll('.nav4k__details'));
  if (!items.length) return;

  var HOVER = window.matchMedia('(hover: hover) and (min-width: 990px)');
  var closeTimer = null;

  function syncAria(details) {
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function closeAll(except) {
    items.forEach(function (d) {
      if (d !== except && d.open) {
        d.open = false;
        syncAria(d);
      }
    });
  }

  items.forEach(function (details) {
    var summary = details.querySelector('summary');
    syncAria(details);

    // Solo un panel abierto a la vez + sincroniza aria al alternar.
    details.addEventListener('toggle', function () {
      syncAria(details);
      if (details.open) closeAll(details);
    });

    // Hover (solo raton en escritorio): abrir al entrar, cerrar al salir con retardo.
    details.addEventListener('mouseenter', function () {
      if (!HOVER.matches) return;
      clearTimeout(closeTimer);
      if (!details.open) {
        details.open = true;
        syncAria(details);
        closeAll(details);
      }
    });
    details.addEventListener('mouseleave', function () {
      if (!HOVER.matches) return;
      closeTimer = setTimeout(function () {
        details.open = false;
        syncAria(details);
      }, 120);
    });

    // Esc cierra y devuelve el foco al summary.
    details.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) {
        details.open = false;
        syncAria(details);
        if (summary) summary.focus();
      }
    });
  });

  // Clic fuera del nav cierra todos los paneles.
  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) closeAll(null);
  });

  // Al perder el foco fuera del nav (tabulacion), cerrar.
  document.addEventListener('focusin', function (e) {
    if (!nav.contains(e.target)) closeAll(null);
  });
})();
